<div layout-vertical padding-lr padding-top>
  <div layout>
    @if (ratingVisible) {
      <rt-interview-results-summary-chart
        [positiveRatings]="positiveRatings!"
        [uniqAdmins]="uniqAdmins"
        [lastUpdate]="lastUpdate"
        [totalRatings]="results.length"
        [evaluationTranslationKey]="evaluationTranslationKey"
      />
    }

    @if (!ratingVisible) {
      <rt-summary-evaluation-meter
        [rating]="positiveRatings"
        isHidden="true"
      ></rt-summary-evaluation-meter>

      <div class="text-wrap" layout-vertical>
        <div class="evaluation-label" text-bold>
          {{ 'app.interview.summary.evaluation_score_is_hidden.title' | translate }}
        </div>
        <span>
          {{ 'app.interview.summary.evaluation_score_is_hidden.content' | translate }}
        </span>
        @if (lastUpdate) {
          <div class="light">
            {{ 'app.interview.summary.overall_last_submitted' | translate }}
            {{ lastUpdate | rtTimeAgoAsync }}
          </div>
        }
      </div>
    }
  </div>
</div>

@if (userEvaluatedCandidateInAtLeastOnePlacementWithFariEvaluationsEnabledAtCurrentStage) {
  <rt-box [variant]="'padding-small'" margin-left margin-top margin-right>
    <rt-icon
      [name]="'remove-red-eye'"
      [size]="'medium'"
      colorToken="colorIconPrimaryDefault"
      [rtTooltip]="'app.interview.summary.evaluation_score_is_hidden.tooltip' | translate"
      margin-right
    ></rt-icon>
    <div text-darkest>
      {{ 'app.interview.summary.evaluation_score_is_hidden.infobox' | translate }}
    </div>
  </rt-box>
}

<div class="list-wrap">
  @for (group of groups; track trackByGroup($index, group)) {
    <rt-interview-result-summary-overall-item
      [group]="group"
      [hasMultiplePlacements]="hasMultiplePlacements()"
      [currentUserAvailablePlacements]="currentUserAvailablePlacements"
      [hasAccessToAllJobOffers]="hasAccessToAllJobOffers"
      (counterClick)="summaryResultCounterClick.emit($event)"
    >
    </rt-interview-result-summary-overall-item>
  }
</div>
